import React, {useEffect, useRef, useState} from 'react';
import { IranMap } from 'react-iran-map';
import {useNavigate} from "react-router-dom";
import {dashboard} from "../../services/dashboard";
import {notify} from "../../functions/tostify";
import {ToastContainer} from "react-toastify";
import FetchLoading from "../FetchLoading";

function Dashboard() {
    const mapData = {
        "ardabil": 0,
        "isfahan": 0  ,
        "alborz": 0,
        "ilam": 0,
        "eastAzerbaijan": 0,
        "westAzerbaijan": 0,
        "bushehr": 0,
        "tehran": 0,
        "chaharmahalandBakhtiari": 0,
        "southKhorasan": 0,
        "razaviKhorasan": 0,
        "northKhorasan": 0,
        "khuzestan": 0,
        "zanjan": 0,
        "semnan": 0,
        "sistanAndBaluchestan": 0,
        "fars": 0,
        "qazvin": 0,
        "qom": 0,
        "kurdistan": 0,
        "kerman": 0,
        "kohgiluyehAndBoyerAhmad": 0,
        "kermanshah": 0,
        "golestan": 0,
        "gilan": 0,
        "lorestan": 0,
        "mazandaran": 0,
        "markazi": 0,
        "hormozgan": 0,
        "hamadan": 0,
        "yazd": 0,
    }
    const situation = [
        ["total","183 , 130 , 255", "#B782FF", "ثبت نامی ها"],
        ["entered","62 , 204 , 170", "#3ECCAA", "شرکت کنندگان"],
        ["active","255 , 225 , 74", "#FFE14A", "کاربران فعال"],
        ["total_entered","53 , 243 , 255", "#35F3FF", "نسبت شرکت کنندگان به ثبت نامی ها"],
        ["entered_active","111 , 255 , 17", "#6FFF11", "نسبت کاربران فعال به شرکت کنندگان"],
    ]
    const [dashboardData, setDashboardData] = useState(null)
    const data = useRef()
    const iranMapRef = useRef();
    const [situationIndex, setSituationIndex] = useState(2)
    const navigate = useNavigate();

    const selectProvinceHandler = (province) => {
        if(dashboardData[province.name] > 0)
            navigate('/state/'+province.name+"/");
        else
            notify("در این استان کسی وارد نشده است", "error")
    }

    useEffect(() => {
            dashboard()
                .then(response => {
                    console.log(response)
                    if (response.status === 200 && response.data.body !== null) {
                        data.current = response.data.body
                        changeMapdata(0)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
    }, [])

    function changeMapdata(itemIndex) {
        setSituationIndex(itemIndex)
        let newMapData = {}
        Object.keys(mapData).map((key, index) => {
            newMapData[key] = data.current[key][situation[itemIndex][0]]
        })
        setDashboardData(null)
        setTimeout(function() {
            setDashboardData(newMapData)
            console.log(newMapData)
        }, 200);
    }

    console.log(dashboardData)
    console.log(situationIndex)

    return (

            (dashboardData !== null) ?
                <div className="flex w-screen h-screen justify-center items-center">
                <div className="fixed top-[0] left-[0] p-[min(0.5vw,1vh)] justify-center flex-row-reverse items-center w-full flex cursor-pointer bg-[#001037] text-white text-[min(2vw,4vh)] font-bold z-[1111]">
                    <div className="absolute left-[1%] p-[min(0.5vw,1vh)] justify-center flex-row-reverse items-center flex cursor-pointer bg-[#ffffff] text-black rounded-md text-[min(1vw,2vh)] z-[1111]" onClick={()=> {navigate("/schools/signup/")}}>
                        اپلود اطلاعات مدرسه جدید
                    </div>
                    <div className="flex flex-row-reverse" onClick={()=> {navigate("/organ-students-data/")}}>
                        اطلاعات کل ارگان
                        <img className="h-[min(3vw,6vh)]" src="https://uploads.zibazi.tv/site/assets/organ/dashboard/up.png" alt="icon"/>
                    </div>
                </div>
                    <div
                        className="flex flex-col absolute right-[min(10vw,20vh)] w-[min(25vw,50vh)] bg-[#001037] z-[9] p-[min(2vw,4vh)] rounded-[min(2vw,4vh)] items-end justify-center">
                    <ToastContainer toastStyle={{borderRadius: 'min(1vw,2vh)'}} rtl/>
                    {situation.map((item, index) => (
                        <div  onClick={() => changeMapdata(index)}
                              className={`flex flex-row text-[min(1vw,2vh)] cursor-pointer justify-center ${index !== situationIndex && "text-white"} white border-[min(0.25vw,0.5vh)] font-bold text-right my-[min(1vw,2vh)] border-[${situation[index][2]}] items-center rounded-[min(0.5vw,1vh)] w-[100%] h-[min(4vw,8vh)] bg-[${index === situationIndex ? situation[situationIndex][2] : "#001037"}]`}>
                            {item[3]}
                        </div>
                    ))}
                    {/*<img src="https://uploads.zibazi.tv/site/assets/organ/dashboard/guide.png" alt="راهنما"*/}
                    {/*     className="fixed bottom-[5%] left-[5%] z-[2] w-[12%]"/>*/}
                </div>
                    <IranMap
                        width={'min(95vh,48vw)'}
                        selectProvinceHandler={selectProvinceHandler}
                        colorRange='0, 158, 40'
                        data={mapData}
                        deactiveProvinceColor='#FFFFFF'
                    />
                    <IranMap
                        ref={iranMapRef}
                        width={'min(95vh,48vw)'}
                        selectProvinceHandler={selectProvinceHandler}
                        colorRange={situation[situationIndex][1]}
                        data={dashboardData}
                        deactiveProvinceColor='#2B4890'
                    />
                </div>
            : <FetchLoading/>
    );
}

export default Dashboard;
